<template>
<div class="animated fadeIn" style="padding-bottom:10px;" :id="id">
  <resize-observer @notify="handleResize" />
  <b-row >
    <b-col sm="1">
    </b-col>
    <b-col sm="5">
      <div class="input-bottom-line">
        <b-row>
          <b-col sm="6">
            <select :id="selectMedia" class="form-control no-border" :class="{error: errors.has(selectMedia)}" :name="selectMedia" v-validate="'required'" v-model="mediaInfo.media" required>
                <option value="" disabled selected hidden>미디어</option>
                <option v-for="(media_obj, media) in mediass" :value="media">{{media}}</option>
            </select>
          </b-col>
          <b-col sm="6">
            <select :id="selectChannel" class="form-control no-border" :class="{error: errors.has(selectChannel)}" :name="selectChannel" v-validate="'required'" v-model="mediaInfo.channel" required>
                <option value="" disabled selected hidden>채널</option>
                <option v-for="(channel_obj, channel) in channels" :value="channel">{{channel}}</option>
            </select>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col sm="2" v-show="allocationPortionON">
      <b-row class="input-bottom-line">
        <b-col sm="6">
          <div class="nospin">
            <b-form-input class="no-border" :class="{error: errors.has(mediaAllocation)}" :name="mediaAllocation" v-validate="'required|min_value:1'" min=1 max=98 v-model="mediaInfo.minmumAllocationPortion" type="number" ></b-form-input>
          </div>
        </b-col>
        <b-col sm="6">
          <div>
            <select class="form-control no-border" v-model="mediaInfo.portionComparator" required>
                <option value='<' label='<'></option>
                <option value='>' label='>'></option>
                <option value='==' label='='></option>
            </select>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="2">
      <div class="input-bottom-line">
        <b-form-input class="no-border" :class="{error: errors.has(mediaCpm)}" :name="mediaCpm" v-validate="'required|min:3'" v-model="mediaInfo.cpmStr" :formatter="format_cpmStr" type="text" ></b-form-input>
      </div>
    </b-col>
    <b-col sm="1">
      <b-button type="submit" size="sm" variant="light" style="background-color:transparent" class="btn-pill" @click="deleteThis">
        <span style="font-size:20px;font-weight:900;">X</span>
      </b-button>
    </b-col>
  </b-row>
</div>
</template>

<script>
import select2 from "select2/dist/js/select2.full.min.js";

import Vue from 'vue'
import VueResize from 'vue-resize'
Vue.use(VueResize)

import reachFormData from "../common/ReachFormData.js";

import numeral from 'numeral';

export default {
  components: {  },
  props: {
    mediaList:null, // 패어런트의 미디어/채널 컴포넌트 리스트
    allocationPortionON:false,
  },
  data() {
    return {
      validationFinish : false,
      mediaInfo : this.$_.clone(reachFormData.mediaInfo),
      id: null,
      selectMedia: 'selectMedia',
      selectChannel: 'selectChannel',
      selectVehicle: 'selectVehicle',
      mediaAllocation: 'mediaAllocation',
      mediaCpm : 'mediaCpm',
      mediass: reachFormData.allocationMediaStructure,
      channels: [],
    }
  },
  beforeCreate: function() {},
  watch: {
    'mediaInfo.minmumAllocationPortion': function(){
      if(this.mediaInfo.minmumAllocationPortion > 99){
        this.mediaInfo.minmumAllocationPortion = 99;
      }
    },
    'mediaInfo.media': function() {
      // Clear previously selected values
      this.channels = [];
      if (this.mediaInfo.media.length > 0) {
        this.channels = this.mediass[this.mediaInfo.media];
      }
    },
  },
  mounted: function() {
    this.$log.debug('MediaTemplate mounted 시작 : ' + this.id);
    this.mediaList["#" + this.id] = this.mediaInfo; // 이거 지금 정상적으로 동작하고 있는 코드인가?
    this.$log.debug('MediaTemplate mounted 종료 : ' + this.id);
  },
  created: function() {
    this.id = this._uid + '_';
    this.mediaCpm = this.id + 'mediaCpm';

    this.selectMedia = this.id + 'selectMedia';
    this.selectChannel = this.id + 'selectChannel';
    this.selectVehicle = this.id + 'selectVehicle';
    this.mediaAllocation = this.id + 'mediaAllocation';

  },
  updated: function() {
  },
  methods: {
    format_cpmStr(value){
      this.mediaInfo.cpmStr = value.replace(/[($)\s\._\-]+/g, '');
      this.mediaInfo.cpm = numeral(this.mediaInfo.cpmStr).format('0');
      return numeral(this.mediaInfo.cpmStr).format('0,0');
    },
    validateCheckFN(){
      this.$log.debug('MediaTemplate validateCheckFN 시작 : ' + this.id);
      this.$validator.validateAll().then(res=>{
        if(res) {
          this.mediaInfo.formValidation = true;
          this.validationFinish = true;
        } else {
          this.mediaInfo.formValidation = false;
          this.validationFinish = true;
        }
      })
      this.$log.debug('MediaTemplate validateCheckFN 종료 : ' + this.id);
    },
    handleResize() {
      this.createSelectFn(this);
    },
    createSelectFn(vm) {
      $('#' + this.selectMedia).on('change', function() {
        vm.$data.mediaInfo.media = this.value;
      });
      $('#' + this.selectChannel).on('change', function() {
        vm.$data.mediaInfo.channel = this.value;
      });
    }, // end createSelectFn
    deleteThis() {
      this.$log.debug('MediaTemplate deleteThis 시작 : ' + this.id + "/" + this.mediaInfo.media + "/" + this.mediaInfo.channel);
      delete this.mediaList["#" + this.id];
      var self = this;
      $("#" + this.id).fadeOut('slow', function() {
        self.$log.debug('MediaTemplate deleteThis 종료 : ' + self.id + "/" + self.mediaInfo.media + "/" + self.mediaInfo.channel);
        document.getElementById(this.id).remove();
      });
    }
  }
}
</script>
<style src="select2/dist/css/select2.min.css"></style><style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>
<style scoped>
</style>
<style>
/* .nospin > input[type=number]::-webkit-inner-spin-button,
.nospin > input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
} */
</style>



// WEBPACK FOOTER //
// src/views/budget/BudgetMediaTemplate.vue